import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import WhatsAppButton from '@/components/layout/WhatsAppButton'
import FirstTimeVisitorDialog from '@/components/layout/FirstTimeVisitorDialog'

// Layout
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import AnnouncementBar from '@/components/layout/AnnouncementBar'

// Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import AccountPage from './pages/AccountPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import ContactPage from './pages/ContactPage'
import ExpressDeliveryPage from './pages/ExpressDeliveryPage'
import FAQPage from './pages/FAQPage'
import OffersPage from './pages/OffersPage'
import PackagingPage from './pages/PackagingPage'
import PrivacyPage from './pages/PrivacyPage'
import ProductsPage from './pages/ProductsPage'
import ProductDetailPage from './pages/ProductDetailPage'
import ReturnsPage from './pages/ReturnsPage'
import ShippingPage from './pages/ShippingPage'
import TermsPage from './pages/TermsPage'
import WishlistPage from './pages/WishlistPage'

// Admin Layout
import AdminLayout from '@/components/admin/AdminLayout'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminLogin from './pages/admin/AdminLogin'
import AdminProducts from './pages/admin/AdminProducts'
import AdminProductNew from './pages/admin/AdminProductNew'
import AdminProductDetail from './pages/admin/AdminProductDetail'
import AdminOrders from './pages/admin/AdminOrders'
import AdminOrderNew from './pages/admin/AdminOrderNew'
import AdminOrderDetail from './pages/admin/AdminOrderDetail'
import AdminPayments from './pages/admin/AdminPayments'
import AdminUsers from './pages/admin/AdminUsers'
import AdminUserNew from './pages/admin/AdminUserNew'
import AdminCategories from './pages/admin/AdminCategories'
import AdminCategoryNew from './pages/admin/AdminCategoryNew'
import AdminCategoryDetail from './pages/admin/AdminCategoryDetail'
import AdminCollections from './pages/admin/AdminCollections'
import AdminCollectionNew from './pages/admin/AdminCollectionNew'
import AdminCollectionDetail from './pages/admin/AdminCollectionDetail'
import AdminSettings from './pages/admin/AdminSettings'
import AdminWishlist from './pages/admin/AdminWishlist'
import AdminAnalytics from './pages/admin/AdminAnalytics'
import AdminPurchases from './pages/admin/AdminPurchases'
import AdminPurchaseNew from './pages/admin/AdminPurchaseNew'
import AdminHeroFeaturedCollections from './pages/admin/AdminHeroFeaturedCollections'
import AdminHeroFeaturedCollectionNew from './pages/admin/AdminHeroFeaturedCollectionNew'
import AdminCoupons from './pages/admin/AdminCoupons'
import AdminCouponNew from './pages/admin/AdminCouponNew'
import AdminOfflineSales from './pages/admin/AdminOfflineSales'
import AdminOfflineSaleNew from './pages/admin/AdminOfflineSaleNew'
import AdminAnnouncements from './pages/admin/AdminAnnouncements'
import AdminAnnouncementNew from './pages/admin/AdminAnnouncementNew'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <AnnouncementBar />
            <Header />
            <HomePage />
            <Footer />
          </>
        } />
        
        <Route path="/about" element={
          <>
            <AnnouncementBar />
            <Header />
            <AboutPage />
            <Footer />
          </>
        } />
        
        <Route path="/account" element={
          <>
            <AnnouncementBar />
            <Header />
            <AccountPage />
            <Footer />
          </>
        } />
        
        <Route path="/cart" element={
          <>
            <AnnouncementBar />
            <Header />
            <CartPage />
            <Footer />
          </>
        } />
        
        <Route path="/checkout" element={
          <>
            <AnnouncementBar />
            <Header />
            <CheckoutPage />
            <Footer />
          </>
        } />
        
        <Route path="/payment-success" element={
          <>
            <AnnouncementBar />
            <Header />
            <PaymentSuccessPage />
            <Footer />
          </>
        } />
        
        <Route path="/contact" element={
          <>
            <AnnouncementBar />
            <Header />
            <ContactPage />
            <Footer />
          </>
        } />
        
        <Route path="/express-delivery" element={
          <>
            <AnnouncementBar />
            <Header />
            <ExpressDeliveryPage />
            <Footer />
          </>
        } />
        
        <Route path="/faq" element={
          <>
            <AnnouncementBar />
            <Header />
            <FAQPage />
            <Footer />
          </>
        } />
        
        <Route path="/offers" element={
          <>
            <AnnouncementBar />
            <Header />
            <OffersPage />
            <Footer />
          </>
        } />
        
        <Route path="/packaging" element={
          <>
            <AnnouncementBar />
            <Header />
            <PackagingPage />
            <Footer />
          </>
        } />
        
        <Route path="/privacy" element={
          <>
            <AnnouncementBar />
            <Header />
            <PrivacyPage />
            <Footer />
          </>
        } />
        
        <Route path="/products" element={
          <>
            <AnnouncementBar />
            <Header />
            <ProductsPage />
            <Footer />
          </>
        } />
        
        <Route path="/products/:slug" element={
          <>
            <AnnouncementBar />
            <Header />
            <ProductDetailPage />
            <Footer />
          </>
        } />
        
        <Route path="/products/classification/:slug" element={
          <>
            <AnnouncementBar />
            <Header />
            <ProductsPage />
            <Footer />
          </>
        } />
        
        <Route path="/returns" element={
          <>
            <AnnouncementBar />
            <Header />
            <ReturnsPage />
            <Footer />
          </>
        } />
        
        <Route path="/shipping" element={
          <>
            <AnnouncementBar />
            <Header />
            <ShippingPage />
            <Footer />
          </>
        } />
        
        <Route path="/terms" element={
          <>
            <AnnouncementBar />
            <Header />
            <TermsPage />
            <Footer />
          </>
        } />
        
        <Route path="/wishlist" element={
          <>
            <AnnouncementBar />
            <Header />
            <WishlistPage />
            <Footer />
          </>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Dashboard route */}
        <Route path="/dashboard" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
        </Route>
        
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="products/new" element={<AdminProductNew />} />
          <Route path="products/:id" element={<AdminProductDetail />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="orders/new" element={<AdminOrderNew />} />
          <Route path="orders/:id" element={<AdminOrderDetail />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="users/new" element={<AdminUserNew />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="categories/new" element={<AdminCategoryNew />} />
          <Route path="categories/:id" element={<AdminCategoryDetail />} />
          <Route path="collections" element={<AdminCollections />} />
          <Route path="collections/new" element={<AdminCollectionNew />} />
          <Route path="collections/:id" element={<AdminCollectionDetail />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="wishlist" element={<AdminWishlist />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="purchases" element={<AdminPurchases />} />
          <Route path="purchases/new" element={<AdminPurchaseNew />} />
          <Route path="purchases/:id" element={<AdminPurchaseNew />} />
          <Route path="hero-featured-collections" element={<AdminHeroFeaturedCollections />} />
          <Route path="hero-featured-collections/new" element={<AdminHeroFeaturedCollectionNew />} />
          <Route path="hero-featured-collections/:id" element={<AdminHeroFeaturedCollectionNew />} />
          <Route path="coupons" element={<AdminCoupons />} />
          <Route path="coupons/new" element={<AdminCouponNew />} />
          <Route path="coupons/:id" element={<AdminCouponNew />} />
          <Route path="offline-sales" element={<AdminOfflineSales />} />
          <Route path="offline-sales/new" element={<AdminOfflineSaleNew />} />
          <Route path="offline-sales/:id" element={<AdminOrderDetail />} />
          <Route path="announcements" element={<AdminAnnouncements />} />
          <Route path="announcements/new" element={<AdminAnnouncementNew />} />
          <Route path="announcements/:id" element={<AdminAnnouncementNew />} />
        </Route>
      </Routes>
      
      <WhatsAppButton />
      <FirstTimeVisitorDialog />
      
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#1f2937",
            color: "#fff",
          },
        }}
      />
    </div>
  )
}

export default App
